var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9940_3942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58528 12.0813C6.77101 12.2672 6.99155 12.4146 7.23428 12.5152C7.47702 12.6158 7.7372 12.6676 7.99995 12.6676C8.2627 12.6676 8.52288 12.6158 8.76561 12.5152C9.00835 12.4146 9.22888 12.2672 9.41461 12.0813L11.5553 9.94067C11.6701 9.81373 11.7316 9.64752 11.7272 9.47644C11.7228 9.30536 11.6528 9.14253 11.5317 9.02165C11.4105 8.90077 11.2476 8.8311 11.0765 8.82707C10.9054 8.82304 10.7393 8.88496 10.6126 9L8.66195 10.9513L8.66661 0.666667C8.66661 0.489856 8.59638 0.320286 8.47135 0.195262C8.34633 0.0702379 8.17676 0 7.99995 0C7.82314 0 7.65357 0.0702379 7.52854 0.195262C7.40352 0.320286 7.33328 0.489856 7.33328 0.666667L7.32728 10.9387L5.38728 9C5.26219 8.875 5.09256 8.8048 4.91571 8.80486C4.73886 8.80493 4.56929 8.87524 4.44428 9.00033C4.31928 9.12543 4.24908 9.29506 4.24915 9.4719C4.24921 9.64875 4.31952 9.81833 4.44461 9.94333L6.58528 12.0813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10.666C15.1565 10.666 14.987 10.7363 14.8619 10.8613C14.7369 10.9863 14.6667 11.1559 14.6667 11.3327V13.9993C14.6667 14.1762 14.5964 14.3457 14.4714 14.4708C14.3464 14.5958 14.1768 14.666 14 14.666H2C1.82319 14.666 1.65362 14.5958 1.5286 14.4708C1.40357 14.3457 1.33333 14.1762 1.33333 13.9993V11.3327C1.33333 11.1559 1.2631 10.9863 1.13807 10.8613C1.01305 10.7363 0.843478 10.666 0.666667 10.666C0.489856 10.666 0.320286 10.7363 0.195262 10.8613C0.0702379 10.9863 0 11.1559 0 11.3327L0 13.9993C0 14.5298 0.210714 15.0385 0.585786 15.4136C0.960859 15.7886 1.46957 15.9993 2 15.9993H14C14.5304 15.9993 15.0391 15.7886 15.4142 15.4136C15.7893 15.0385 16 14.5298 16 13.9993V11.3327C16 11.1559 15.9298 10.9863 15.8047 10.8613C15.6797 10.7363 15.5101 10.666 15.3333 10.666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9940_3942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.5b590419e2a6f3d4210add2370c7919d.svg";
export { ForwardRef as ReactComponent };